/** @format */

import { MessageTemplateActionTypes } from './message-template.types';
const INITIAL_STATE = {
  templates: [
    {
      subject: 'Full Parking (NON-ALTO)',
      message:
        'Hi [name], JSX is unable to accommodate any more personal vehicles at our [airportCode] location, including Valet, because the lot is full. We regret the inconvenience this may cause and encourage you to instead utilize rideshare services.',
      html: `<b style="color:red;">YOUR JSX CREW</b>`,
      id: 'd-ee93fab1c9af4871a2a38b527b72ef73',
      location: 'General',
    },
    {
      subject: 'Miami Heat DEP',
      message:
        'Hi [name], Your flight, [flightId] on [date] will depart from the main Signature Flight Support facility located at 5700 NW 36th St, Miami, FL 33122. If you have any questions, please call (800) 435-9579 for assistance.',
      html: '',
      id: 'd-b53af2d03eef40aeb569a8495d5546c9',
      location: 'MIA',
    },
    {
      subject: 'Miami Heat ARR',
      message:
        'Hi [name], Your flight, [flightId] on [date] will arrive at the main Signature Flight Support facility located at 5700 NW 36th St, Miami, FL 33122. If you have any questions, please call (800) 435-9579 for assistance.',
      html: '',
      id: 'd-db43194318b14ac8b39445b45387a03f',
      location: 'MIA',
    },
    {
      subject: 'President TFR',
      message: `Hi [name], Your JSX flight [flightID] has been impacted by a Temporary Flight Restriction (TFR) put in place by the FAA. This is due to the U.S. President's travel to the region on [date]. The estimated departure time of your flight is [flightDepTime].`,
      html: '',
      id: 'd-ca11b87051c543018ee3f0af4cb8d6ab',
      location: 'General',
    },
    {
      subject: 'Vice President TFR',
      message: `Hi [name], Your JSX flight [flightID] has been impacted by a Temporary Flight Restriction (TFR) put in place by the FAA. This is due to the U.S. Vice President's travel to the region on [date]. The estimated departure time of your flight is [flightDepTime].`,
      html: '',
      id: 'd-aa9de0f600294facac18160f6b88acd2',
      location: 'General',
    },
    {
      subject: 'Road Closure',
      message:
        'Hi [name], We’re looking forward to flying with you today, but wanted to let you know that there are road closures near the JSX [airportCode] location. You may need to allow extra time to reach the airport. See you soon!',
      html: '',
      id: 'd-710dd4c5db0547509e7baa9eed320f05',
      location: 'General',
    },
    // {
    //   subject: 'Flight Back On Time',
    //   message:
    //     'Hello [name],\nGood News, [flightID] is back on time! We understand your time is valuable, and we will inform you of any changes. Check your flight status https://www.jsx.com/home/flight-status.',
    //   html: '',
    //   id: 'd-b4f0923d799f49e6a2aaac3f9fb8f30b',
    // },
    {
      subject: 'Full Parking (BUR/LAX/DAL/HOU)',
      message:
        'Hi [name], JSX is unable to accommodate any personal vehicles at our [airportCode] location, including Valet, because the lot is full. Our rideshare partner Alto offers fully sanitized luxury vehicles to ensure you travel comfortably to the airport. Check them out and book a ride at https://www.ridealto.com.',
      html: '',
      id: 'd-8a708cf6b37945bca1e93a8d16921d6e',
      location: 'Multiple',
    },
    {
      subject: 'Super Bowl (SNA)',
      message:
        "Hi [name], it's JSX! Due to heavy traffic anticipated in Orange County, we strongly encourage you to travel to/from the airport using rideshare services like Uber. Message us on your favorite social media platform @flyjsx if you have any questions.",
      html: '',
      id: 'd-e26bebb2bde741368360df90f6acb50a',
      location: 'SNA',
    },
    // 3fbd86ee07ab4b67aae2af97fe578d35
    {
      subject: 'Custom Message',
      message: '',
      html: '',
      id: 'd-3fbd86ee07ab4b67aae2af97fe578d35',
      location: 'General',
    },
    // {
    //   subject: 'JSX Travel Alert (LAS)',
    //   message:
    //     'JSX Travel Alert: South Las Vegas Blvd will be closed on 2/27 (3pm-9pm) and normal access routes to JSX will be blocked. Please allow extra time to/from the airport. For step-by-step directions on how to reach our facility, click here: https://bit.ly/JSXAlert',
    //   html: '',
    //   id: 'd-3fbd86ee07ab4b67aae2af97fe578d35',
    //   location: 'LAS',
    // },
    {
      subject: 'TEMP LAX',
      message:
        'Hi [name], JSX is unable to accommodate any more personal vehicles at our [airportCode] location.  We regret the inconvenience this may cause and encourage you to instead utilize rideshare services.',
      html: '',
      location: 'LAX',
      id: 'd-70eb4ce163ec49d684943e2df759f729',
    },
    {
      subject: 'MRY Car Event - Departure',
      message: `Hi [name], Your flight, [flightId] on [date] will depart from the main Monterey Jet Center facility located at 300 Sky Park Drive Monterey CA,  93940. Parking will not be available, rideshare service is encouraged. If you have any questions, please call (800) 435-9579 for assistance.`,
      html: '',
      id: 'd-7a72a05d02ac4214b19d94e346636185',
      location: 'MRY',
    },
    {
      subject: 'MRY Car Event - Arrival',
      message: `Hi [name], Your flight, [flightId] on [date] will arrive at the main Monterey Jet Center facility located at 300 Sky Park Drive Monterey CA,  93940. If you have any questions, please call (800) 435-9579 for assistance.`,
      html: '',
      id: 'd-11163a0efb024bd888e3081ab6666fb9',
      location: 'MRY',
    },
    {
      subject: 'HPN Move - Arrival',
      message: `Hi [name], Your flight, [flightId] on [date] will arrive at the main Atlantic Aviation (West) 67 Tower Road White Plains, NY 10604. If you have any questions, please call (800) 435-9579 for assistance.`,
      html: '',
      id: 'd-dd96008551d647978311c1714088bd0e',
      location: 'HPN',
    },
    {
      subject: 'HPN Move - Departure',
      message: `Hi [name], Your flight, [flightId] on [date] will depart from the main Atlantic Aviation (West) 67 Tower Road White Plains, NY 10604. Parking will not be available, rideshare service is encouraged. If you have any questions, please call (800) 435-9579 for assistance.`,
      html: '',
      id: 'd-5b1a1b38ef164f898f931912082923ac',
      location: 'HPN',
    },
    {
      subject: 'President TFR Early',
      message: `Hi [name]. Because of a Temporary Flight Restriction (TFR) put in place due to the President’s travel to the region, your JSX flight [flightId] will need to depart EARLIER than scheduled to prevent a long delay. Your new estimated departure time is [flightDepTime]. Please contact JSX Customer Support at (800) 435-9579 if you have any questions or need assistance.`,
      html: '',
      id: 'd-2508e78577a24a8696dbbf94f77cdedc',
      location: 'General',
    },
    {
      subject: 'TAOS Initial',
      message: `Hi [name]. You are currently reserved on JSX flight [flightID] departing from [dep] at [flightDepTime] on [date]. This flight will arrive in [arr] at [flightArrTime].If you have any questions, please contact Customer Support at (800) 435-9579 or see a JSX Airport Service Concierge.`,
      html: '',
      id: 'd-880029a01bbe42cfa349d59d41bd3f7a',
      location: 'TAOS',
    },
    {
      subject: 'Flight Cancellation',
      message: `Hi [name]. Your JSX flight [flightID] has been cancelled. Please contact Customer Support at (800) 435-9579 for assistance. A JSX voucher in the value of $200 sent separately via email for the inconvenience caused.
PNR: [pnr]`,
      html: '',
      id: 'd-6954e37bb743465487cce7a18fd55475',
      location: 'General',
    },
  ],
};

const messageTemplateReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MessageTemplateActionTypes.ADD_MESSAGE:
      return state;

    case MessageTemplateActionTypes.REMOVE_TEMPLATE:
      return { ...state };

    default:
      return state;
  }
};

export default messageTemplateReducer;
